import { AuthService } from './../../shared/models/auth.service';
import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, RequestOptionsArgs, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WeGoConfig, IAPIResponse, DataListModel } from '../../shared/config';
import { JQueryHelperService } from './../../shared/models/jquery-helper.service';
import { ReportFilterModel } from "./report-filter.model";

@Injectable()
export class MaintenancePlanningReportService {
  JQueryHelper: JQueryHelperService = new JQueryHelperService();
  constructor(private authService: AuthService, private http: Http) { }

  public GetOdometerValuePerVehicleList(model: ReportFilterModel): Observable<IAPIResponse> {
    let getUrl = WeGoConfig.API_GET_MAINTENANCE_PLANNING_VEHICLE_LIST;
    let queryStringReportFilterModel = this.JQueryHelper.Param(model);
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    getUrl = getUrl + "?" + decodeURIComponent(queryStringReportFilterModel);

    return this.http.get(getUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ExportOdometerValuePerVehicleReportPDF(model: ReportFilterModel): any {
    let getUrl = WeGoConfig.API_GET_MAINTENANCE_PLANNING_VEHICLE_LIST_PDF;
    let queryStringReportFilterModel = this.JQueryHelper.Param(model);
    getUrl = getUrl + "?" + decodeURIComponent(queryStringReportFilterModel);

    let headers = this.authService.GetHeader('application/pdf');
    let options = new RequestOptions({ headers: headers, responseType: ResponseContentType.Blob });
    return this.http.get(getUrl, options);
  }



  public ExportOdometerValuePerVehicleReportExcel(model: ReportFilterModel): any {
    let getUrl = WeGoConfig.API_GET_MAINTENANCE_PLANNING_VEHICLE_LIST_XLS;
    let queryStringReportFilterModel = this.JQueryHelper.Param(model);
    getUrl = getUrl + "?" + decodeURIComponent(queryStringReportFilterModel);

    let headers = this.authService.GetHeader('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
    let options = new RequestOptions({ headers: headers, responseType: ResponseContentType.Blob });
    return this.http.get(getUrl, options);
  }
 

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/report/models/maintenance-planning.service.ts